import gql from 'graphql-tag';
import { commercialOutageFields } from './get-commercial-outage';

export const createCommercialOutage = gql`
  ${commercialOutageFields}
  mutation createCommercialOutage($input: CommercialOutageInput!) {
    createCommercialOutage(input: $input) {
      ...CommercialOutageFields
    }
  }
`;

export const updateCommercialOutage = gql`
  ${commercialOutageFields}
  mutation updateCommercialOutage($id: ID!, $input: CommercialOutageInput!) {
    updateCommercialOutage(id: $id, input: $input) {
      ...CommercialOutageFields
    }
  }
`;
